<div class="modal-header container-fluid ab-modal__header" tabindex="0">
  <h3 class="modal-title ab-modal__title">Keyboard Shortcuts</h3>
  <div class="ab-modal__close">
    <button
      class="btn btn--link-color btn--no-shadow"
      type="button"
      (click)="activeModal.dismiss()"
    >
      <i class="glyphicon glyphicon--45-deg glyphicon-ab-plus"></i>
    </button>
  </div>
</div>
<div class="modal-body ab-modal__body">
  <dl class="ab-shortcuts-list">
    <dt>j / k</dt>
    <dd>next / previous error</dd>
    <dt>↓ / ↑</dt>
    <dd>next / previous error</dd>
    <dt>r</dt>
    <dd>resolve / unresolve current error</dd>
    <dt>m</dt>
    <dd>mute / unmute current error</dd>
    <dt>u</dt>
    <dd>undo last action</dd>
    <dt>x</dt>
    <dd>select / deselect current error</dd>
    <dt>shift + r</dt>
    <dd>resolve / unresolve selected errors</dd>
    <dt>shift + m</dt>
    <dd>mute / unmute selected errors</dd>
    <dt>shift + ?</dt>
    <dd>show / hide keyboard shortcuts</dd>
  </dl>
</div>
